<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <h5>
                    Rendimentos e Impostos Retidos na Fonte
                    <btn-exportar
                        v-if="rendimentos.length > 0 && ($temAcessoView('DIRFS-02') || $temAcessoView('FORN-DIRF-00'))"
                        class="float-right"
                        :dirfBeneficiarioId="dirfBeneficiarioId"
                        :beneficiario="beneficiario"
                        :anoCalendario="anoCalendario"
                        :dirfsServicos="dirfsServicos"
                        :fornecedorId="fornecedorId"
                    ></btn-exportar>
                </h5>
            </b-card-header>
            <b-card-body>
                <app-tabela
                    idTabela="tblRendimentos"
                    :itens="rendimentos"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :mostrarFiltro="false"
                >
                    <template slot="rendimento" slot-scope="data">
                        {{
                        data.rendimento | currency
                        }}
                    </template>
                    <template slot="impostoRetido" slot-scope="data">
                        {{
                        data.impostoRetido | currency
                        }}
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import BtnExportar from './BtnExportarRendimentos'

export default {
	props: {
		rendimentos: {
			type: Array,
			default: () => []
		},

		dirfBeneficiarioId: {
			type: String,
			default: () => ''
		},

		beneficiario: {
			type: String,
			default: () => ''
		},

		anoCalendario: {
			type: String,
			default: () => ''
		},

		dirfsServicos: {
			type: Object,
			default: () => {}
		},

		fornecedorId: {
			type: String,
			default: () => null
		}
	},

	components: { BtnExportar },

	data() {
		return {
			campos: [
				{
					key: 'mes',
					label: 'Mês'
				},
				{
					key: 'codigoRetencao',
					label: 'Código Retenção',
					tdClass: 'text-center'
				},
				{
					key: 'descricaoRetencao',
					label: 'Descrição do Rendimento'
				},
				{
					key: 'rendimento',
					label: 'Rendimento',
					tdClass: 'text-nowrap text-right'
				},
				{
					key: 'impostoRetido',
					label: 'Imposto Retido',
					tdClass: 'text-nowrap text-right'
				}
			],
			itensPorPagina: 0
		}
	},

	methods: {},

	created() {},

	computed: {},

	watch: {}
}
</script>
